import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

interface Query extends URLSearchParams {
  append(name: string, value: string): void;
  delete(name: string): void;
}

const useSearchQuery = (): Query => {
  const location = useLocation();
  const history = useHistory();
  const query = useMemo(() => new URLSearchParams(location.search), [location]);

  query.append = useCallback(
    (name: string, value: string) => {
      const currentQuery = new URLSearchParams(location.search);
      currentQuery.append(name, value);
      history.push({ search: currentQuery.toString() });
    },
    [history, location.search]
  );

  query.delete = useCallback(
    (name: string) => {
      const currentQuery = new URLSearchParams(location.search);
      currentQuery.delete(name);
      history.push({ search: currentQuery.toString() });
    },
    [history, location.search]
  );

  return useMemo(() => query, [query]);
};

export default useSearchQuery;
